import { LOCAL__collection_cells_delete } from '@/state/collection/cell/LOCAL__collection_cells_delete';
import { LOCAL__grid2d_cells_delete } from '@/state/grid2d/grid2d_cell/LOCAL__grid2d_cells_delete';
import { store } from '@/state/store';
import { assert_array_instanceof } from '@shared/asserts/utils_asserts';
import { DTO__grid2d_cell } from '@shared/dto/grid2d_cell/DTO__grid2d_cell';

export function HANDLER_CLIENT__grid2d_cells_delete(items: any) {
  assert_array_instanceof(items, DTO__grid2d_cell);

  store.dispatch(LOCAL__collection_cells_delete(items));

  store.dispatch(LOCAL__grid2d_cells_delete(items));
}
